module.exports = __webpack_public_path__ + "static/media/verdeOccupy.ee5a3019.jpg";